import { render, staticRenderFns } from "./CompletedTaskCard.vue?vue&type=template&id=d0ccabce&scoped=true&"
import script from "./CompletedTaskCard.vue?vue&type=script&lang=js&"
export * from "./CompletedTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./CompletedTaskCard.vue?vue&type=style&index=0&id=d0ccabce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ccabce",
  null
  
)

export default component.exports